// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

import $ from 'jquery';

import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker.js';
import 'select2';
import 'bootstrap/js/dist/popover';
import './angle/modules/forms/validation';

$(function() {
    if ($.fn.colorpicker) $('.theme-colorpicker').colorpicker();
    // if ($.fn.select2) $('.select2').select2({ theme: 'bootstrap4' });
});
